import { Injectable, inject } from '@angular/core';

import { ApiService } from '@features/api';
// import { LoadingStatus } from '@features/common';

import { Location } from '../models';

export interface LocationResponse {
  location: Location;
  redirect?: boolean;
  external_url?: string;
}

@Injectable({ providedIn: 'root' })
export class LocationService {
  api = inject(ApiService);

  // loadingStatus = signal<LoadingStatus>(LoadingStatus.NotLoaded);

  // #locations = signal<{ id: string; name: string; selected: boolean }[]>([]);
  // locations = this.#locations.asReadonly();

  // populate() {
  //   if (this.loadingStatus() === LoadingStatus.NotLoaded) {
  //     this.loadingStatus.set(LoadingStatus.Loading);
  //     this.api
  //       .get<{ data: { id: string; name: string; selected: boolean }[] }>('/notifications/locations')
  //       .pipe(
  //         tap(({ data }) => this.#locations.set(data)),
  //         catchError(() => {
  //           return of([]);
  //         }),
  //         finalize(() => {
  //           this.loadingStatus.set(LoadingStatus.Loaded);
  //         }),
  //       )
  //       .subscribe();
  //   }
  // }

  subscriptions() {
    return this.api.get<{ data: { id: string; name: string; selected: boolean }[] }>('/notifications/locations');
  }

  list(params: { show_all?: boolean } = {}) {
    return this.api.get<Location[]>('/locations', params);
  }

  /**
   * Returns the full response envelope (not just the location) so callers can act
   * on the partner-venue `redirect`/`external_url` signal.
   */
  get(id: string) {
    return this.api.get<LocationResponse>(`/locations/${id}`);
  }
}
